import { useMemo } from 'react';
import { useProducts } from '@/data/Content/Products';

const parseSkus = (skus: string | string[]) =>
	Array.isArray(skus)
		? skus
		: skus
				.split(',')
				.map((sku) => sku.trim())
				.filter(Boolean);

export const useCatalogEntrySearch = (skus: string | string[]) => {
	const skuList = useMemo(() => parseSkus(skus), [skus]);
	const { products, loading } = useProducts({ partNumber: skuList });

	const orderedProducts = useMemo(
		() => [...products].sort((a, b) => skuList.indexOf(a.partNumber) - skuList.indexOf(b.partNumber)),
		[products, skuList]
	);

	return { skuList, products: orderedProducts, loading };
};
